<template>
    <div class="shipments-overview">
        <div class="shipments-overview__header">
            <v-btn
                dark
                color="#967adc"
                class="shipments-overview__create-btn"
                @click="createShipment"
            >
                {{ $t('pages.shipments.createShipment') }}
            </v-btn>
        </div>

        <ShipmentsFilters
            @filters-change="updateFilters"
            @reset-filters="resetFilters"
        />

        <div>
            <ShipmentsTable @sort-change="updateSort" />
        </div>

        <v-pagination
            v-if="pagination && pagination.lastPage > 1"
            v-model="page"
            class="pagination"
            :total-visible="7"
            :length="pagination.lastPage"
            color="#3bafda"
            @input="onPageChange"
        ></v-pagination>
    </div>
</template>

<script>
import ShipmentsFilters from '@/components/shipments/shipments-filters'
import ShipmentsTable from '@/components/shipments/shipments-table'
import { mapActions, mapGetters } from 'vuex'
import { actionTypes, getterTypes } from '@/store/modules/shipments'

export default {
    name: 'ShipmentsOverview',
    components: { ShipmentsFilters, ShipmentsTable },
    data: () => ({
        page: 1,
        localFilters: {
            status: '',
            search: '',
            dateFrom: '',
            dateTo: '',
            usmanager_id: null,
        },
    }),
    computed: {
        ...mapGetters('shipments', {
            getAllShipments: getterTypes.getAllShipments,
            filters: getterTypes.getFilters,
            paginationStore: getterTypes.getPagination,
        }),
        pagination: function () {
            return this.getAllShipments.pagination ?? null
        },
    },
    watch: {
        paginationStore: {
            handler(newPagination) {
                if (newPagination && newPagination.currentPage) {
                    this.page = newPagination.currentPage
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.page = this.paginationStore?.currentPage || 1
    },
    methods: {
        ...mapActions('shipments', {
            setFiltersAction: actionTypes.setFilters,
            setPaginationAction: actionTypes.setPagination,
            setSortAction: actionTypes.setSort,
            resetFiltersAction: actionTypes.resetFilters,
        }),
        fetchShipments: async function () {
            try {
                const { dateFrom, dateTo, usmanager_id, ...otherFilters } =
                    this.localFilters

                const filters = {
                    ...otherFilters,
                    ...(dateFrom && dateTo
                        ? {
                              'created[from]': dateFrom,
                              'created[to]': dateTo,
                          }
                        : {}),
                }

                if (usmanager_id) {
                    filters.usmanager_id = Number(usmanager_id)
                }

                if (!usmanager_id) {
                    filters.usmanager_id = null
                }

                await this.setFiltersAction(filters)
            } catch (error) {
                console.error('Error fetching shipments:', error)
            }
        },
        updateFilters: function (filters) {
            this.localFilters = { ...filters }
            this.page = 1
            this.fetchShipments()
        },
        onPageChange: function (page) {
            this.page = page
            this.setPaginationAction({ currentPage: page })
        },
        updateSort: function (value) {
            this.setSortAction(value)
        },
        createShipment: function () {
            this.$router.push('/shipments-create')
        },
        resetFilters: function () {
            const date = new Date()
            const year = date.getFullYear()
            const month = date.getMonth() + 1
            const day = date.getDate()
            const addZero = (data) => (data < 10 ? '0' + data : data)
            const today = `${year}-${addZero(month)}-${addZero(day)}`

            this.localFilters = {
                status: 'opened',
                search: '',
                dateFrom: '2026-01-01',
                dateTo: today,
                usmanager_id: null,
            }
            this.page = 1
            this.fetchShipments()
        },
    },
}
</script>

<style lang="scss" scoped>
.shipments-overview {
    width: 100%;

    &__header {
        display: flex;
        margin-bottom: 16px;
    }

    &__create-btn {
        max-width: 200px;
        color: #fff;
    }
}

.pagination {
    padding: 8px 0 0 0 !important;
}
</style>
